var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{staticClass:"mb-6",attrs:{"height":400,"options":_vm.chartOptions,"chart-data":_vm.chartData}})}
var staticRenderFns = []

export { render, staticRenderFns }